export const reMessageToAdminTypesConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		REQUEST : 'GET_PAGED_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		FAILURE : 'GET_PAGED_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'GET_LIST_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'GET_LIST_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'CREATE_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'CREATE_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'DELETE_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'DELETE_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'UPDATE_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'UPDATE_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_MESSAGE_TO_ADMIN_TYPES_REQUEST',
		SUCCESS : 'RESTORE_MESSAGE_TO_ADMIN_TYPES_SUCCESS',
		FAILURE : 'RESTORE_MESSAGE_TO_ADMIN_TYPES_FAILURE'
	},
	CLEAR: 'CLEAR_MESSAGE_TO_ADMIN_TYPES'
}

